module.exports = __webpack_public_path__ + "img/bnr_special_01.6cbe7fd1.jpg";